import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { FormField } from '../../../dto/util/form-field';
import { AutenticacionService } from '../services/autenticacion.service';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';
import { TranslateService } from "@ngx-translate/core";
import { combineLatest } from "rxjs";
import { EmpresaService } from '../services/empresa.service';

@Component({
  selector: 'app-modal-restablecer-contrasenia',
  templateUrl: './modal-restablecer-contrasenia.component.html',
  styleUrl: './modal-restablecer-contrasenia.component.scss',
})
export class ModalRestablecerContraseniaComponent implements OnInit {
  @ViewChild('modalRestablecerContrasenia')
  modalRestablecerContrasenia!: ElementRef;

  fieldsCambioContrasenia: FormField[] = [];
  formGroup?: FormGroup;
  // Multilenguaje
  comunText: any = {};
  restablecerContraseniaText: any = {};

  @Input() isFuncionario: boolean = true;
  constructor(
    private autenticacionService: AutenticacionService,
    private alertaModalService: AlertaModalService,
    private readonly translate: TranslateService,
    private empresaService: EmpresaService
  ) { }

  ngOnInit(): void {
    combineLatest({
      contrasenia: this.translate.stream('restablecer-contrasenia'),
      comun: this.translate.stream('comun-label'),
    }).subscribe(({ contrasenia, comun }) => {
      // Asignar traducciones a variables
      this.restablecerContraseniaText = contrasenia;
      this.comunText = comun;
      this.creacionFormulario();
    });
  }

  creacionFormulario() {
    this.fieldsCambioContrasenia = [
      {
        name: 'correoUsuario',
        label:
          this.restablecerContraseniaText['correo'],
        type: 'email',
        placeholder: this.comunText['email-placeholder'],

        required: true,
        width: '12',
        visible: true,
        validation: [Validators.maxLength(50), Validators.email],
        errorMessages: {
          required: this.restablecerContraseniaText['correo-required'],
          email: this.restablecerContraseniaText['correo-invalido'],
          maxlength: this.restablecerContraseniaText['correo-maxlength'],
        },
      },
    ];
  }

  onSubmitResetContrasena(form: FormGroup) {
    if (this.isFuncionario) {
      this.autenticacionService
        .restablecerConstraseniaCorreoElectronico(
          form.get('correoUsuario')?.value
        )
        .subscribe({
          next: resp => {
            form.reset();
            this.alertaModalService.exito(
              this.restablecerContraseniaText['solicitud-enviada'],
              this.restablecerContraseniaText['revise-correo']
            );
          },
          error: error => {
            form.reset();
            this.alertaModalService.error(
              this.restablecerContraseniaText['error-password'],
              error.error.message
            );
          },
        });
    } else {
      const json = {
        email: form.get('correoUsuario')?.value
      }
      this.empresaService.restablecerPasswordEmail(
        json
      ).subscribe({
        next: resp => {
          form.reset();
          this.alertaModalService.exito(
            this.restablecerContraseniaText['solicitud-enviada'],
            this.restablecerContraseniaText['revise-correo']
          );
        },
        error: error => {
          form.reset();
          this.alertaModalService.error(
            this.restablecerContraseniaText['error-password'],
          );
        },
      });
    }

  }
  restablecerForm() {
    if (this.formGroup != undefined) {
      this.formGroup.reset();
    }
    this.abrirCerrarModal();
  }

  onChangeForm(form: FormGroup) {
    this.formGroup = form;
  }

  abrirCerrarModal() {
    this.modalRestablecerContrasenia.nativeElement.click();
  }
}
